import {useState} from 'react';

export default class AbstractEntity {

  public id: any;
  public setId: any;
  public ativo: any;
  public setAtivo: any;

  constructor() {
    [this.id, this.setId] = useState(null);
    [this.ativo, this.setAtivo] = useState(null);
  }

  sync(entity: any) {
    this.setId(entity.id);
    this.setAtivo(entity.ativo);
  }

  public obterExtensao(str: any) {
    if (!str || str.indexOf('.') < 0) {
      return 'undef';
    }
    const split = str.split('.');
    return split[split.length - 1];
  }


}
